import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

import SettingsPage from '../partials/SettingsPage';
import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';
import DeleteDialog from './DeleteDialog';

import { Button, Text, Small, Panel, H4, Table, TableFigure, Box } from '@bigcommerce/big-design';
import { AddIcon, EditIcon, DeleteIcon } from '@bigcommerce/big-design-icons';

import { suppliersIndex, deleteSupplier, clearNew } from '../../redux/actions/suppliers';

const Suppliers = ({ payload, suppliers, loadSuppliers, destroySupplier, clearNewSupplier}) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [activeId, setActiveId] = useState(false);

  useEffect(() => {
    loadSuppliers(payload);
    clearNewSupplier();
  }, []);

  const removeSupplier = (id) => {
    destroySupplier(payload, id);
    setShowDeleteDialog(false);
  }

  const deleteDialog = (id) => {
    setActiveId(id);
    setShowDeleteDialog(true);
  }

  const description = () => {
    return(
      <> 
        <Text>From this page, you can create, modify or delete suppliers.</Text>
        <Text>Suppliers are the organizations or individuals who supply inventory for your store. Stored information about suppliers includes their names and contact information, default tax settings, payment terms and payment methods.</Text>
        <Small>Have questions or need some help? Contact us at <a href="mailto:support@athousandapps.com">support@athousandapps.com</a></Small>
      </>
    )
  }

  return(
    <>
      <PageHeader stripeBackground='#c66628' helpLink="bigcommerce/manage-suppliers/" />
      <SettingsPage title="Suppliers" description={description()}>
        <Panel>
          <H4>Suppliers</H4>
          { suppliers.status === 'success' && suppliers.suppliers.length > 0 &&
            <TableFigure>
              <Table
                columns={[
                    { header: 'Supplier Name', hash: 'supplier_name', render: ({ supplier_name }) => supplier_name },
                    { header: 'Actions', hash: 'stock', render: ({ id }) => 
                      <>
                        <Link to={`/supplier/edit/${id}`}>
                          <span className="left-15 bottom-15"><Button variant="secondary" iconLeft={<EditIcon />}>Edit</Button></span>
                        </Link>
                        <span className="left-15 bottom-15"><Button variant="secondary" iconLeft={<DeleteIcon />} actionType="destructive" onClick={() => deleteDialog(id)}>Delete</Button></span>
                      </> },
                  ]}
                  items={suppliers.suppliers}
              >
              </Table>
              <Link to="/supplier/new">
                <Button iconLeft={<AddIcon />}>New Supplier</Button>
              </Link>
            </TableFigure>
          }
          { suppliers.status !== 'success' &&
            <LoadingSpinner statusText="Loading suppliers" />
          }

          { suppliers.suppliers.length === 0 && !suppliers.isFetching &&
              <Box
                backgroundColor="warning10"
                border="box"
                borderRadius="normal"
                padding="medium"
              >
                <div className="text-center">
                  <Text>No suppliers set. Create suppliers to see and manage them in a list here.</Text>
                  <Link to="/supplier/new">
                    <Button iconLeft={<AddIcon />}>New Supplier</Button>
                  </Link>
                </div>
              </Box>
            }

        </Panel>
      </SettingsPage>

      { showDeleteDialog && 
        <DeleteDialog
          payload={payload}
          setShowDeleteDialog={setShowDeleteDialog}
          removeSupplier={removeSupplier}
          activeId={activeId}
          showDeleteDialog={showDeleteDialog}
        />
      }
    </>
  )
}

const mapStateToProps = state => ({
  suppliers: state.suppliers,
});

const mapDispatchToProps = (dispatch) => ({
  loadSuppliers: (payload) => dispatch(suppliersIndex(payload)),
  destroySupplier: (payload, supplierId) => dispatch(deleteSupplier(payload, supplierId)),
  clearNewSupplier: () => dispatch(clearNew()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Suppliers);